import { Component, OnInit } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { AuthFacade } from "src/app/domains/auth/store/facade/auth.facade";

@Component({
  selector: "gdp-login-container",
  templateUrl: "./login-container.component.html",
  styleUrls: ["./login-container.component.scss"]
})
export class LoginContainerComponent implements OnInit {
  error;

  constructor(
    private facade: AuthFacade
  ) { }

  ngOnInit() {
    this.facade.error$.subscribe((error: HttpErrorResponse) => {
      if (error) {
        this.error = "auth.login.error";
      }
    });

    this.facade.login();
  }
}
